import { connect } from 'react-redux';

import LiveDataGraph from 'components/live/LiveDataGraph';
import { getLiveGraphParams } from "selectors/liveParams";
import { getAllMonitoringParameters } from 'selectors/turbineParams';

// windTurbine can be momentarily undefined during navigation between two
// turbines' detail pages - see components/dashboard/CardHeader.js's guard
// for the crash this caused. mapStateToProps runs on every store update.
const mapStateToProps = (state, ownProps) => {
  const windTurbineId = ownProps.windTurbine && ownProps.windTurbine.id;
  return {
    liveProps: getLiveGraphParams(state, windTurbineId),
    monitoringParams: getAllMonitoringParameters(state, windTurbineId),
  };
};

export default connect(mapStateToProps)(LiveDataGraph);
